import React from "react";
import { useQuery } from '@apollo/client';
import { GET_STATISTICS_QUERY } from "../../queries/queries";
import Error from "../error";
import Loading from "../loading";
import Achievements from "./achievements";
import useMakeScrollable from "../../custom_hooks/make-scrollable";
import AchievementsContext from "../../contexts/achievements-context";

const AchievementsContainer = () => {
  useMakeScrollable();

  const { loading, error, data } = useQuery(GET_STATISTICS_QUERY, {
    fetchPolicy: "no-cache"
  });

  if (loading) return <Loading />;
  if (error) return <Error />;

  return (
    <AchievementsContext.Provider value={data.statistics}>
      <Achievements />
    </AchievementsContext.Provider>
  );
};

export default AchievementsContainer;
